import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPaperclip24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconPaperclip24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.451 4.635c-.568.557-.951 1.405-.951 2.57v8.03C6.5 17.525 8.62 20 11.353 20c1.467 0 2.897-.393 3.94-1.174 1.016-.762 1.707-1.92 1.707-3.59V6.823h1.5v8.411c0 2.153-.92 3.752-2.308 4.792-1.363 1.02-3.132 1.473-4.839 1.473C7.737 21.5 5 18.298 5 15.235v-8.03c0-1.51.506-2.764 1.402-3.641.89-.874 2.107-1.314 3.422-1.314 1.317 0 2.504.443 3.362 1.327.856.884 1.314 2.137 1.314 3.629v8.03c0 1.612-1.257 2.661-2.765 2.661-1.586 0-2.7-1.303-2.735-2.642-.013-.497-.013-2.615-.01-4.59L8.996 8 9 7.143v-.322l.75.003.75.002v.084l-.001.238-.003.856-.006 2.664c-.003 1.99-.003 4.078.01 4.547a1.243 1.243 0 0 0 1.235 1.182c.786 0 1.265-.48 1.265-1.162v-8.03c0-1.183-.358-2.034-.892-2.584-.532-.549-1.308-.871-2.284-.871-.98 0-1.8.324-2.373.885m2.302 1.439a.75.75 0 0 1 .747.752l-.75-.002L9 6.82a.75.75 0 0 1 .753-.747m7.997 0a.75.75 0 0 1 .75.75H17a.75.75 0 0 1 .75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPaperclip24);
